import { TOptions } from 'i18next'

import { TReplaceOptions } from 'cng-common/features/translations/components/translation/models/replaceOptions'

export type TTranslationFunction = (
  key: string | TemplateStringsArray,
  options?: TOptions
) => string

interface IGetTranslatedTitleParams {
  t: TTranslationFunction
  key: string
  replaceParams?: TReplaceOptions[]
  skipInterpolation?: boolean
}

export const replaceKeysInTranslation = (
  translatedText: string,
  replaceParams?: TReplaceOptions[]
) => {
  let result = translatedText
  if (replaceParams) {
    replaceParams.forEach((item) => {
      result = result.replaceAll(item.key, item.value)
    })
  }
  return result
}

export const getTranslatedText = ({
  t,
  key,
  replaceParams,
  skipInterpolation = true,
}: IGetTranslatedTitleParams): string => {
  const base = t(key, {
    interpolation: {
      skipOnVariables: skipInterpolation,
    },
  })

  return replaceKeysInTranslation(base, replaceParams)
}
